<template>
  <div class="icon-component" :style="[{height: height + '!important'},{width: width + '!important'}]">
    <div v-if="getIconNames === getIconNames.toUpperCase()" class="icon" :class="{'icon-hover': cursorPointer}"
         :style="[{'-webkit-mask-image': 'url(' + imagePath(getIconNames, iconType)+')'},
               {'mask-image': 'url(' + imagePath(getIconNames, iconType)+')'},{width: width},
               {height: height},{backgroundColor: colorCode || getColors[color] || getColors.primary}]"></div>

    <font-awesome-icon v-else
                       :icon="[`fa${getIconWeight}`, getIconNames]"
                       :style="{
                         fontSize: width,
                         color: colorCode || getColors[color] || getColors.primary
                       }"/>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
// import custom kit icons
import {
  faSolidCartShoppingRotate,
  faRegularCartShoppingRotate,
  faSolidBagShoppingRotate,
  faRegularBagShoppingRotate,
  faRegularBagShoppingLocationPin,
  faRegularBagShoppingGlobe,
  faRegularBagShoppingCircleEllipsis,
  faRegularCartShoppingLocationPin,
  faRegularCartShoppingGlobe,
  faRegularCartShoppingCircleEllipsis,
  faRegularArrowUpRightDotsCirclePlus,
  faRegularArrowUpRightDotsLocationPin,
  faRegularArrowUpRightDotsGlobe
} from '@awesome.me/kit-056688db4a/icons/js/all'
import {mapGetters} from 'vuex'
export default {
  name: 'customIcon',
  props: {
    width: {
      type: String,
      default: '20px'
    },
    height: {
      type: String,
      default: '22px'
    },
    icon: {
      type: String,
      default: ''
    },
    iconType: {
      type: String,
      default: 'svg',
      validator (value) {
        return ['svg', 'png', 'jpg', 'jpeg', 'webp'].includes(value)
      }
    },
    iconWeight: {
      type: String,
      default: 'light',
      validator (value) {
        return ['light', 'regular', 'solid', 'duotone', 'kit'].includes(value)
      }
    },
    color: {
      type: String,
      default: () => {
        return 'primary'
      },
      validator (value) {
        if (value) {
          return ['success', 'danger', 'warning', 'gray', 'dark-gray', 'primary', 'purple', 'white'].includes(value || 'success')
        } else {
          return true
        }
      }
    },
    colorCode: {
      type: String,
      default: () => {
        return ''
      }
    },
    cursorPointer: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      colors: {
        'primary': '#197ed5',
        'success': '#28c76f',
        'warning': '#ffa146',
        'danger': '#ea5455',
        'purple': '#b93f91',
        'gray': '#cecece',
        'dark-gray': '#626262',
        'white': '#ffffff'
      }
    }
  },
  computed: {
    ...mapGetters({
      isMobile: 'isMobile'
    }),
    getColors () {
      const colors = {
        'primary': this.isMobile ? '#3b6ef5' : '#197ed5',
        'success': this.isMobile ? '#34a853' : '#28c76f',
        'warning': this.isMobile ? '#ff9f43' : '#ffa146',
        'danger': this.isMobile ? '#fe4444' : '#ea5455',
        'purple': '#b93f91',
        'gray': '#cecece',
        'dark-gray': '#626262',
        'white': '#ffffff'
      }

      return colors
    },
    getIconNames () {
      switch (this.icon) {
      case 'plus-icon':
        return 'plus-large'

      case 'edit-icon':
        return 'pen-line'

      case 'save-icon':
        return 'floppy-disk'

      case 'print-icon':
        return 'print'

      case 'list-icon':
        return 'list-check'

      case 'setting-icon':
        return 'gear'

      case 'trash-icon':
        return 'trash-can'

      case 'bin-recycle-icon':
        return 'trash-can'

      case 'solid-cart-shopping-rotate-icon1':
        return faSolidCartShoppingRotate

      case 'regular-cart-shopping-rotate-icon1':
        return faRegularCartShoppingRotate

      case 'solid-bag-shopping-rotate-icon1':
        return faSolidBagShoppingRotate

      case 'regular-bag-shopping-rotate-icon1':
        return faRegularBagShoppingRotate

      case 'regular-bag-shopping-location-pin-icon1':
        return faRegularBagShoppingLocationPin

      case 'regular-bag-shopping-globe-icon1':
        return faRegularBagShoppingGlobe

      case 'regular-bag-shopping-circle-ellipsis-icon1':
        return faRegularBagShoppingCircleEllipsis

      case 'regular-cart-shopping-location-pin-icon1':
        return faRegularCartShoppingLocationPin

      case 'regular-cart-shopping-globe-icon1':
        return faRegularCartShoppingGlobe

      case 'regular-cart-shopping-circle-ellipsis-icon1':
        return faRegularCartShoppingCircleEllipsis

      case 'regular-arrow-up-right-dots-circle-plus-icon1':
        return faRegularArrowUpRightDotsCirclePlus

      case 'regular-arrow-up-right-dots-location-pin-icon1':
        return faRegularArrowUpRightDotsLocationPin

      case 'regular-arrow-up-right-dots-globe-icon1':
        return faRegularArrowUpRightDotsGlobe

      default:
        return this.icon.replace('-icon', '')
      }
    },
    getIconWeight () {
      switch (this.getIconNames) {
      case 'solid-cart-shopping-rotate':
      case 'regular-cart-shopping-rotate':
      case 'solid-bag-shopping-rotate':
      case 'regular-bag-shopping-rotate':
      case 'regular-bag-shopping-location-pin':
      case 'regular-bag-shopping-globe':
      case 'regular-bag-shopping-circle-ellipsis':
      case 'regular-cart-shopping-location-pin':
      case 'regular-cart-shopping-globe':
      case 'regular-cart-shopping-circle-ellipsis':
      case 'regular-arrow-up-right-dots-circle-plus':
      case 'regular-arrow-up-right-dots-location-pin':
      case 'regular-arrow-up-right-dots-globe':
        return 'k'

      default:
        switch (this.iconWeight) {
        case 'light':
        case 'solid':
        case 'regular':
        case 'duotone':
        case 'kit':
          return this.iconWeight[0]
        }
      }
    }
  },
  methods: {
    imagePath (name, type) {
      return require(`@/assets/icons/${  name  }.${  type}`)
    }
  }
}
</script>

<style lang="scss" scoped>

div.icon-component {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  .icon {
    display: inline-block;
    background-size: cover;
    mask-position: center !important;
    -webkit-mask-position: center !important;
    mask-repeat: no-repeat !important;
    margin: auto !important;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    &.icon-hover {

      &:hover, &:focus {
        cursor: pointer;
        filter: invert(27%) sepia(5%) hue-rotate(10deg) brightness(100%) contrast(90%);
      }
    }
  }
}

@supports (-webkit-touch-callout: none) {
  /* CSS specific to iOS devices */
  @media print {
    .icon-component {
      .icon {
        background-color: unset !important;
      }
    }
  }
}

</style>
